import { useSyncExternalStore } from 'react'

const q = '(min-width: 1024px)'

/** No matchMedia (tests, old engines): the desktop layout. */
const hasMedia = () => typeof matchMedia === 'function'

export function useWide(): boolean {
  return useSyncExternalStore(
    (cb) => {
      if (!hasMedia()) return () => {}
      const m = matchMedia(q)
      m.addEventListener('change', cb)
      return () => m.removeEventListener('change', cb)
    },
    () => (hasMedia() ? matchMedia(q).matches : true),
    () => false,
  )
}
